import { render, staticRenderFns } from "./GridPuestos.vue?vue&type=template&id=688afb20&scoped=true&"
import script from "./GridPuestos.vue?vue&type=script&lang=js&"
export * from "./GridPuestos.vue?vue&type=script&lang=js&"
import style0 from "./GridPuestos.vue?vue&type=style&index=0&id=688afb20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688afb20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VImg,VRow})
